import React from 'react';
import { motion } from 'framer-motion';
import { EyeIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { heroChips } from '../data/hero';
export function Hero() {
  return <header className="bg-radial-glow relative overflow-hidden" data-id="element-69" data-mp="9ka7f386p0z1">
      <div className="mx-auto max-w-4xl px-5 pb-6 pt-[15px] text-center" style={{
      paddingTop: "0px"
    }} data-id="element-70" data-mp="9igxnf29y0mt">
        <h1 className="mx-auto mt-2 max-w-2xl font-display text-[23px] font-black uppercase leading-tight text-plum sm:text-[34px]" style={{
        paddingTop: "8px",
        marginTop: "-10px",
        marginBottom: "-10px"
      }} data-id="element-71" data-mp="129h0hmovcycw">
          Raporlarınızı <span className="text-blush" data-id="element-72" data-mp="sarsclmrys9u">saniyeler içinde</span> <span className="text-grape" data-id="element-73" data-mp="sde3ev8vjpwt">profesyonel</span> bir yapıya kavuşturun
        </h1>

        <p className="pb-5 pt-3 font-display text-[11px] font-bold uppercase tracking-[0.2em] text-plum/60 sm:text-sm" style={{
        paddingTop: "17px",
        paddingBottom: "10px"
      }} data-id="element-74" data-mp="nbyhz22sbhdw">
          Vardiya sonu evrak yükünü azaltmak için tasarlanmış kapsamlı yapay zekâ komutları ve profesyonel raporlama çerçeveleri
        </p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.1,
        ease: [0.23, 1, 0.32, 1]
      }} className="relative mx-auto w-full max-w-2xl" data-id="element-75" data-mp="3j6ocnm8x2qr5">
          <img src="https://cdn.magicpatterns.com/uploads/sHdrgebaHzrKAKvcTtfBPn/Kit_Sigma_Smart_de_Reportes_Tacticos.webp" alt="100+ Taktik Rapor Yapay Zekâ Komutu™ — 6 Ciltlik Görsel Sistem + 4 Profesyonel Bonus" width={1536} height={1024} sizes="(min-width: 640px) 600px, 100vw" fetchPriority="high" decoding="async" className="animate-floaty mx-auto h-auto w-full max-w-[600px] object-contain" data-id="element-76" data-mp="3e7l802wummjp" />
        </motion.div>

        <p className="mt-4 text-[10px] font-semibold uppercase tracking-[0.18em] text-plum/50" data-id="element-77" data-mp="2vglq1lnruczx">
          100+ TAKTİK RAPOR YAPAY ZEKÂ KOMUTU™ — 6 Ciltlik Görsel Sistem + 4 Profesyonel Bonus · SIGMA SMART™ Yöntemi · ⭐ 4,9/5 (500'den fazla yetkili memnun kaldı) · ⚡ Anında erişim
        </p>

        <div className="mt-8 flex flex-col items-center" data-id="element-78" data-mp="s3uqvwnx98am">
          <CTAButton href="#pricing" data-id="element-79" data-mp="najgxmntcbeh">Tüm sistemi görüntüle</CTAButton>

          <p className="mx-auto mt-4 max-w-2xl text-[14px] text-plum/70 sm:text-lg" data-id="element-80" data-mp="ibp18tl572yl">
            <span className="font-bold text-plum" data-id="element-81" data-mp="ddf3cb819o9a">2026 İÇİN GELİŞTİRİLEN PROFESYONEL YAPAY ZEKÂ DESTEKLİ RAPORLAMA SİSTEMİ.</span> Raporlarını daha düzenli, tutarlı ve hızlı hazırlamak isteyen kolluk kuvvetleri personeli, soruşturma görevlileri, amirler ve diğer profesyoneller için tasarlanmıştır.
          </p>

          <h2 className="mx-auto mt-4 max-w-2xl text-[16px] font-bold text-grape-deep sm:text-xl" data-id="element-82" data-mp="1126o4hjan4c1">
            Olay raporları · Olay yeri ve delil belgeleri · Müdahale kayıtları · Kriz yönetimi · İstihbarat analizleri · İdari raporlar
          </h2>

          <div className="mt-6 flex flex-wrap justify-center gap-2.5" data-id="element-83" data-mp="3lu9x916uryb8">
            {heroChips.map(({
            icon: Icon,
            label
          }) => <span key={label} className="inline-flex items-center gap-1.5 rounded-full border border-grape/20 bg-white/80 px-3.5 py-1.5 text-xs font-semibold text-plum/80" data-id="element-84" data-mp="1x9ulmd6nbhoh">
                <Icon className="h-3.5 w-3.5 text-grape" data-id="element-85" data-mp="269zhpr6e2tnc" />
                {label}
              </span>)}
          </div>

          <p className="mt-4 text-sm font-semibold text-plum/50" data-id="element-86" data-mp="2b196yqo0zuyp">
            - İhtiyacınız olan raporlama kaynakları tek bir dijital koleksiyonda -
          </p>
        </div>

        <div className="mt-5 inline-flex items-center gap-2 rounded-full border border-blush/40 bg-blush-soft px-4 py-1.5 text-xs font-bold uppercase tracking-wide text-blush-deep" data-id="element-87" data-mp="2kyvntiovxwlb">
          🔥 Sınırlı süreli teklif · Fiyat kısa süre içinde 2.660 TRY'ye dönecek
        </div>

        <p className="mt-4 flex items-center justify-center gap-1.5 text-xs font-medium text-plum/50" data-id="element-88" data-mp="2tysflt6knbkl">
          <EyeIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-89" data-mp="uokdxodx9t6s" />
          12 görevli bu taktiksel seti inceliyor.
        </p>
      </div>
    </header>;
}